export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  const defaultUrls = config.state.paramsClient.display_default_urls;
  const URL =
    defaultUrls && defaultUrls.twitter !== '' ? defaultUrls.twitter : 'https://twitter.com/twitter';

  domc.addType('social-icons-twitter', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'twitter',
          tagName: 'div',
          src: URL,
          resizable: {
            step: 0.2,
            minDim: 10,
            currentUnit: 1,
            autoHeight: true,
          },
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1,
            },
          ],
          script: function() {
            setTimeout(() => {
              const id = this.id;
              const src = `{[ src ]}`;

              let element = document.querySelector('#' + id);
              let elementHref = element.querySelector('.twitter-timeline');
              elementHref.href = src;
              elementHref.setAttribute('height', '100%');
              elementHref.setAttribute('width', '100%');

              var script = document.createElement('script');
              script.type = 'text/javascript';
              script.charset = 'utf-8';
              script.src = '//platform.twitter.com/widgets.js';
              script.async = true;
              document.head.appendChild(script);
            }, 500);
          },
        }),

        init() {
          let attrs = JSON.parse(JSON.stringify(this.attributes));

          if (attrs && attrs.classes && attrs.classes[0] && attrs.classes[0].name) {
            this.set('attributes', { class: attrs.classes[0].name });
          } else {
            this.set('attributes', { class: generateClass() });
          }
          this.listenTo(this, 'change:src', this.updateSrc);
          this.listenTo(this, 'change:width ', this.updateWidth);
          this.listenTo(this, 'change:height ', this.updateHeight);
        },
        updateSrc() {
          this.view.getIframe();
          this.view.render();
          localStorage.setItem('gjs-js', editor.getJs());
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'social-icons-twitter' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },

      getScript() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        script.src = 'https://platform.twitter.com/widgets.js';
        script.async = true;
        return script;
      },
      updateSrcComponentTwitter() {
        let localStorageComponents = JSON.parse(localStorage.getItem('gjs-components'));
        const getAllComponents = (model, result = []) => {
          result.push(model);
          model.components().each(mod => getAllComponents(mod, result));
          return result;
        };
        const all = getAllComponents(editor.DomComponents.getWrapper());
        let twitterModel = all.find(item => item.attributes.attributes.id === this.el.id);
        const updateComponent = (arr, index) => {
          try {
            if (arr[index].attributes.id === this.el.id) {
              arr[index] = twitterModel;
            } else {
              arr[index].components.forEach((m, i, a) => updateComponent(a, i));
            }
          } catch (e) {
            console.log(e);
          }
        };
        localStorageComponents.forEach((m, index, arr) => updateComponent(arr, index));
        localStorage.setItem('gjs-components', JSON.stringify(localStorageComponents));
        localStorage.setItem('gjs-components2', JSON.stringify(localStorageComponents));
      },
      getIframe() {
        var a = this.el.querySelector('a.twitter-timeline');
        if (a) {
          a.href = this.model.get('src');
          a.setAttribute('height', '100%');
          a.setAttribute('width', '100%');
        }
        if (this.el.querySelector('.content_iframe')) {
          while (this.el.firstChild) {
            this.el.removeChild(this.el.firstChild);
          }

          var widget_twitter = document.createElement('div');
          widget_twitter.className = this.ppfx + 'no-pointer';
          var a = document.createElement('a');
          var linkText = document.createTextNode('Tweets by @TwitterDev');
          a.appendChild(linkText);

          a.href = this.model.get('src');
          a.className = 'twitter-timeline';
          a.id = 'twitt_widget_new';
          a.setAttribute('height', '100%');
          a.setAttribute('width', '100%');
          widget_twitter.appendChild(a);
          this.el.appendChild(widget_twitter);
          this.el.appendChild(this.getScript());
        }
        return this.el;
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getIframe();
        } else if (this.el.querySelector('.content_iframe')) {
          this.getIframe();
        }
        // this.el.appendChild(this.getScript());

        localStorage.setItem('gjs-js', editor.getJs());
        this.updateSrcComponentTwitter();
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/twitter/components.js